import { IConfiguration } from "../../../domain/configuration";
import { IDocumentRegistry, IDocumentRepository, IDocumentKindRepository, IAuthenticationService, IRichTextRepository } from "../../../domain/document";
import { DocumentRepository, DocumentKindRepository, RichTextRepository } from ".";
import { AuthenticationService } from "./AuthenticationService";

export class DocumentRegistry implements IDocumentRegistry {
  constructor(private _getConfiguration: () => IConfiguration, private _getToken: () => string) {
  }

  getDocumentRepository(): IDocumentRepository {
    return new DocumentRepository(this._getConfiguration, this._getToken);
  }

  getDocumentKindRepository(): IDocumentKindRepository {
    return new DocumentKindRepository(this._getToken);
  }

  getAuthenticationService(): IAuthenticationService {
    return new AuthenticationService(this._getToken);
  }

  getRichTextRepository(): IRichTextRepository {
    return new RichTextRepository(this._getToken);
  }
}
